/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'members': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M10.835 11.354a2.54 2.54 0 100-5.08 2.54 2.54 0 000 5.08z" _stroke="#fff" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" d="M15.273 15.222a3.872 3.872 0 00-3.872-3.872h-1.209a3.872 3.872 0 00-3.872 3.872M5.468 7.471a1.953 1.953 0 100-3.907 1.953 1.953 0 000 3.907z" _stroke="#fff" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path pid="2" d="M5.901 7.47h-.93a2.978 2.978 0 00-2.977 2.978" _stroke="#fff" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path pid="3" d="M4.643 7.47h.93c.905 0 1.715.406 2.26 1.042" _stroke="#fff" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/members.js